import { combineReducers } from "redux";
import auth from "./auth";
import interfaceComponents from "./interface";
import i18n from "./i18n";
import jobs from "./jobs";
import task from "./task";
import menuReducer from "./menuReducer";

import funnel from "#app/store/RTK/slices/funnelSlice";
import funnelUser from "#app/store/RTK/slices/funnelUserSlice";
import clientPayments from "#app/store/RTK/slices/clientPaymentsSlice";
import clientRatingsSliceReducer from "#app/store/RTK/slices/clientRatingsSlice";
import settingsSliceReducer from "#app/store/RTK/slices/settingsSlice";
import atonSliceReducer from "#app/store/RTK/slices/atonSlice";
import clientServicesSliceReducer from "#app/store/RTK/slices/clientServicesSlice";
import clientSliceReducer from "#app/store/RTK/slices/clientSlice";
import selectedClientIdsReducer from "#app/store/RTK/slices/selectedClientIdsSlice";
import contactsSliceReducer from "#app/store/RTK/slices/contactsSlice";
import applicationsSliceReducer from "#app/store/RTK/slices/applicationsSlice";
import chatSliceReducer from "#app/store/RTK/slices/chatSlice";
import notificationsSliceReducer from "#app/store/RTK/slices/notificationsSlice";
import tasksSliceReducer from "#app/store/RTK/slices/tasksSlice";
import calendarSliceReducer from "#app/store/RTK/slices/calendarSlice";
import featureFlagsSliceReducer from "#app/store/RTK/slices/featureFlagsSlice";
import servicesConstructorReducer from "#app/store/RTK/slices/servicesSlice";
import funnelDataReducer from "#app/store/RTK/slices/funnelDataSlice";
import duplicatesReducer from "#app/store/RTK/slices/duplicatesSlice";
import { baseApi } from "#app/api";

// Импортируем все API для регистрации endpoints
import "#app/api/applicationsApi";
import "#app/api/contacts/rtk";
import "#app/api/clients/rtk";
import "#app/api/tasksApi";
import "#app/api/services/rtk";
import "#app/api/filesApi";
import "#app/api/hierarchy/rtk";
import "#app/api/permissions/rtk";
import "#app/api/settingsApi";

export default () =>
    combineReducers({
        // @TODO всё, что можно увести в слайсы ртк, лучше увести в слайсы
        auth,
        jobs,
        interfaceComponents,
        i18n,
        task,
        funnel,
        funnelUser,
        clientPayments,
        aton: atonSliceReducer,
        clientServices: clientServicesSliceReducer,
        client: clientSliceReducer,
        clientRatings: clientRatingsSliceReducer,
        settings: settingsSliceReducer,
        selectedClientIds: selectedClientIdsReducer,
        contacts: contactsSliceReducer,
        applications: applicationsSliceReducer,
        chat: chatSliceReducer,
        notifications: notificationsSliceReducer,
        tasks: tasksSliceReducer,
        calendar: calendarSliceReducer,
        featureFlags: featureFlagsSliceReducer,
        servicesConstructor: servicesConstructorReducer,
        funnelData: funnelDataReducer,
        duplicates: duplicatesReducer,
        menu: menuReducer,
        [baseApi.reducerPath]: baseApi.reducer,
    });
